// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let frameTypeEnum = {
    'FullDepth': 1,
    'Wsp': 2,
    'Ideal': 4,
    'Manley': 8
};

export default frameTypeEnum;
